import { Injectable, NgZone } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ConfiguredToastrService } from '../../helper/toastr/configured-toastr.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {

  constructor(
    private ngZone: NgZone,
    private toasterService: ConfiguredToastrService,
    ) { }

  getClientErrorMessage(error: Error): string {
    if (!navigator.onLine) {
      return 'No Internet Connection';
    }
    return error.message ? error.message : error.toString();
  }

  getClientStack(error: Error): string {
    return error.stack ?? '';
  }

  getServerErrorMessage(error: HttpErrorResponse): string {
    if (!navigator.onLine) {
      return 'No Internet Connection';
    } else if (error.error) {
      return error.error.message;
    } else {
      return error.message;
    }
  }

  getServerErrorTitle(error: HttpErrorResponse): string {
    if (error.error) {
      return error.error.title;
    } else {
      return error.statusText;
    }
  }

  getServerStack(error: HttpErrorResponse): string {
    // TODO handle server stack trace
    return 'stack';
  }

  showError(message: string, title?: string) {
    this.ngZone.run(() => {
      this.toasterService.error(message, title);
    });
  }
}
